import type { Platform } from '@multimod/shared';
import { PlatformIcon } from '@/components/ui/platform-icon';

export function PlatformBadge({ platform }: { platform: Platform }) {
  return (
    <span
      role="img"
      data-platform={platform}
      aria-label={platform}
      className="plat-pill inline-flex items-center justify-center w-4 h-3.5 rounded-sm border"
    >
      <PlatformIcon platform={platform} size={9} />
    </span>
  );
}
